import * as React from "react";
import { styled, useTheme } from "@mui/material/styles";
import MuiDrawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import DashboardIcon from "@mui/icons-material/Dashboard";
import { Link } from "react-router-dom";

const drawerWidth = 240;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

export default function MiniDrawer(props) {
  return (
    <Drawer
      variant="permanent"
      open={props.open}
    >
      {props.visible && (
        <DrawerHeader>
          <IconButton
            sx={{
              marginTop: '0px'
            }}
            onClick={() => {
              props.handleDrawer(!props.open);
            }}
          >
            <MenuIcon />
          </IconButton>
        </DrawerHeader>
      )}
      <List
        sx={ !props.visible ? { paddingTop: '100px'} : '' }
      >
        <ListItem key={"dashboard"} disablePadding sx={{ display: "block" }}>
          <Link to="/" className="linkMen">
            <ListItemButton
              sx={{
                minHeight: 48,
                justifyContent: props.open ? "initial" : "center",
                px: 2.5,
              }}
              className="linkbtn"
            >
              <ListItemIcon
                sx={{
                  minWidth: 0,
                  mr: props.open ? 1.5 : "auto",
                  justifyContent: "center",
                }}
              >
                <DashboardIcon style={{ color: "white" }} />
              </ListItemIcon>
              <ListItemText
                primary={<span style={{fontFamily: 'GolosTextWebRegular', letterSpacing: '0.02857em', fontSize: '18px'}}>Dashboard</span>}
                className="linktxt"
                sx={{ opacity: props.open ? 1 : 0 }}
              />
            </ListItemButton>
          </Link>
        </ListItem>
      </List>
    </Drawer>
  );
}
